<!-- Legacy hero banner. The rebranded layout uses a plain page heading instead. -->
<div class="hero" *ngIf="!useRebranded">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">My pets</span>
          <br />
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4 mb-5">
  <h1 *ngIf="useRebranded" class="page-title display-5 fw-bold text-center mb-4">My Pets</h1>
  <div class="row mt-3">
    <div class="col-12">
      <div
        *appFeatureFlag="'isArchivePetsAvailable'"
        class="row mt-4 mb-4 me-2"
        [ngClass]="'justify-content-end'"
      >
        <mat-slide-toggle
          [(ngModel)]="showArchivedPets"
          (change)="onShowArchivedChanged($event)"
          class="px-0 w-auto"
        >
          Show archived pets
        </mat-slide-toggle>
      </div>
      <div
        class="row row-cols-1 row-cols-md-3 row-cols-lg-4 d-flex"
        [ngClass]="filteredListOfPets.length < 3 ? 'justify-content-center' : ''"
      >
        <div *ngFor="let pet of filteredListOfPets" class="col mb-4 text-center">
          <div class="card h-100 d-inline-block d-flex flex-column bg-light">
            <div class="card-image-wrapper">
              <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-orange"></div>
              <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-icon">
                <img
                  src="/assets/images/home/triangle-exclamation.svg"
                  class="petplan-image banner-left"
                  alt="petplan-banner"
                />
              </div>
              <img [src]="getPetImageUrl(pet.imageId)" class="card-image" />
            </div>

            <div class="card-body">
              <div class="pet-name mb-4">{{ pet.name }}</div>
              <div class="pet-date-of-birth-text">Date of birth</div>
              <div class="pet-date-of-birth mb-4">{{ pet.dob | date: 'MM/y' }}</div>
            </div>

            <div class="view-pet-information-wrapper mb-3">
              <button
                type="button"
                class="btn btn-primary view-pet-information"
                [routerLink]="navigateToPetDetailPage(pet.id)"
              >
                View Pet Information
              </button>
            </div>
            <div
              class="view-pet-information-wrapper mb-3"
              *ngIf="pet.name === '[to_be_completed_by_keeper]'"
            >
              <button
                type="button"
                class="btn btn-primary view-pet-information"
                [routerLink]="['/my-pet', pet.id, 'confirm']"
              >
                Complete registration
              </button>
            </div>
          </div>
        </div>

        <div *appFeatureFlag="'isPetClaimAvailable'" class="col mb-4 text-center">
          <div class="card h-100 d-inline-block d-flex flex-column bg-light">
            <div class="card-image-wrapper">
              <img src="/assets/images/placeholders/paw-square-image.png" class="card-image" />
            </div>

            <div class="body-placeholder"></div>

            <div class="view-pet-information-wrapper mb-3">
              <button
                type="button"
                class="btn btn-primary view-pet-information"
                routerLink="/claim-pet"
                [queryParams]="addPetQueryParams"
              >
                Add Pet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
